var ResponseCode = /*#__PURE__*/ function(ResponseCode) {
    ResponseCode[ResponseCode["Successful"] = 1] = "Successful";
    ResponseCode[ResponseCode["UsernameNotFound"] = 2] = "UsernameNotFound";
    ResponseCode[ResponseCode["InvalidPhoneNumber"] = 3] = "InvalidPhoneNumber";
    ResponseCode[ResponseCode["PasswordIsInCorrect"] = 4] = "PasswordIsInCorrect";
    ResponseCode[ResponseCode["UserLocked"] = 5] = "UserLocked";
    ResponseCode[ResponseCode["NeedCaptcha"] = 7] = "NeedCaptcha";
    ResponseCode[ResponseCode["NeedOtp"] = 8] = "NeedOtp";
    ResponseCode[ResponseCode["CaptchaVerificationFailed"] = 9] = "CaptchaVerificationFailed";
    ResponseCode[ResponseCode["InvalidCredentials"] = 10] = "InvalidCredentials";
    ResponseCode[ResponseCode["OtpVerificationFailed"] = 11] = "OtpVerificationFailed";
    ResponseCode[ResponseCode["UsernameExists"] = 12] = "UsernameExists";
    ResponseCode[ResponseCode["PasswordAlreadyUsed"] = 13] = "PasswordAlreadyUsed";
    ResponseCode[ResponseCode["NeedPhoneAssociation"] = 14] = "NeedPhoneAssociation";
    ResponseCode[ResponseCode["PhoneAssociationFailed"] = 15] = "PhoneAssociationFailed";
    ResponseCode[ResponseCode["DidNotMeetCriteria"] = 16] = "DidNotMeetCriteria";
    ResponseCode[ResponseCode["Unauthenticated"] = 17] = "Unauthenticated";
    ResponseCode[ResponseCode["ErrorOccurred"] = 20] = "ErrorOccurred";
    ResponseCode[ResponseCode["InvalidQueryParameter"] = 21] = "InvalidQueryParameter";
    ResponseCode[ResponseCode["FeatureNotEnabled"] = 22] = "FeatureNotEnabled";
    ResponseCode[ResponseCode["GetPartnerTokenFailed"] = 23] = "GetPartnerTokenFailed";
    ResponseCode[ResponseCode["AllowDeletion"] = 24] = "AllowDeletion";
    ResponseCode[ResponseCode["UpComingBooking"] = 25] = "UpComingBooking";
    ResponseCode[ResponseCode["PastBookingTooRecent"] = 26] = "PastBookingTooRecent";
    ResponseCode[ResponseCode["HasSpecialRole"] = 27] = "HasSpecialRole";
    ResponseCode[ResponseCode["DeletionIncomplete"] = 28] = "DeletionIncomplete";
    ResponseCode[ResponseCode["PartnerClaimTokenNotFound"] = 29] = "PartnerClaimTokenNotFound";
    ResponseCode[ResponseCode["OtpVerificationLimitExceeded"] = 30] = "OtpVerificationLimitExceeded";
    ResponseCode[ResponseCode["OtpNotRequired"] = 36] = "OtpNotRequired";
    ResponseCode[ResponseCode["OtpTypeToBeSelected"] = 42] = "OtpTypeToBeSelected";
    ResponseCode[ResponseCode["CouldNotSendEmail"] = 32] = "CouldNotSendEmail";
    ResponseCode[ResponseCode["CouldNotSendOtp"] = 37] = "CouldNotSendOtp";
    ResponseCode[ResponseCode["PhoneAlreadyVerified"] = 38] = "PhoneAlreadyVerified";
    ResponseCode[ResponseCode["MagicLinkSent"] = 39] = "MagicLinkSent";
    ResponseCode[ResponseCode["RequestBlocked"] = 41] = "RequestBlocked";
    ResponseCode[ResponseCode["NotAValidTransaction"] = 45] = "NotAValidTransaction";
    ResponseCode[ResponseCode["NeedSignupInfo"] = 47] = "NeedSignupInfo";
    ResponseCode[ResponseCode["OtpSendCountExceeded"] = 35] = "OtpSendCountExceeded";
    ResponseCode[ResponseCode["DobRequired"] = 48] = "DobRequired";
    ResponseCode[ResponseCode["NeedPinInput"] = 49] = "NeedPinInput";
    ResponseCode[ResponseCode["NeedPinSetup"] = 50] = "NeedPinSetup";
    ResponseCode[ResponseCode["IncorrectPin"] = 51] = "IncorrectPin";
    ResponseCode[ResponseCode["NeedPinAndOtp"] = 52] = "NeedPinAndOtp";
    ResponseCode[ResponseCode["NeedConsentInfo"] = 53] = "NeedConsentInfo";
    return ResponseCode;
}({});

var OtpType = /*#__PURE__*/ function(OtpType) {
    OtpType["Phone"] = "phone";
    OtpType["Email"] = "email";
    OtpType["Push"] = "push";
    OtpType["Text"] = "text";
    OtpType["EmailAndPush"] = "email_push";
    OtpType["Whatsapp"] = "whatsapp";
    return OtpType;
}({});

var GdprEraseStatus = /*#__PURE__*/ function(GdprEraseStatus) {
    GdprEraseStatus[GdprEraseStatus["Error"] = -1] = "Error";
    GdprEraseStatus[GdprEraseStatus["AllowDeletion"] = 0] = "AllowDeletion";
    GdprEraseStatus[GdprEraseStatus["UpComingBooking"] = 1] = "UpComingBooking";
    GdprEraseStatus[GdprEraseStatus["PastBookingTooRecent"] = 2] = "PastBookingTooRecent";
    GdprEraseStatus[GdprEraseStatus["HasSpecialRole"] = 3] = "HasSpecialRole";
    GdprEraseStatus[GdprEraseStatus["DeletionIncomplete"] = 4] = "DeletionIncomplete";
    return GdprEraseStatus;
}({});

var OtpChannelStatus = /*#__PURE__*/ function(OtpChannelStatus) {
    OtpChannelStatus["Success"] = "Success";
    OtpChannelStatus["Failure"] = "Failure";
    return OtpChannelStatus;
}({});

export { GdprEraseStatus, OtpChannelStatus, OtpType, ResponseCode };
